<template lang="html">

    <v-container  >
        <v-layout row wrap  v-show="!documentReady">
            <v-container style="text-align: center">

                    <v-progress-circular
                            :size="50"
                            color="primary"
                            indeterminate
                    ></v-progress-circular>


                    <p style="padding-top: 10px !important;">Loading form...</p>

            </v-container>
        </v-layout>
    <v-layout row wrap v-if="document != undefined"  v-show="documentReady">
        <v-container style="text-align: left">
            <froalaView v-model="document.content"></froalaView>
        </v-container>
    </v-layout>
        <v-layout row wrap v-if="document != undefined"  v-show="documentReady && allChecked != false">


            <v-flex xs12>
                <p style="margin-bottom: 0px; font-family: 'Dancing Script', cursive; font-size: 35px; display: inline-block; border-bottom: 1px solid black; padding: 10px; padding-bottom: 0px;">{{sigTest}}</p>
                <br/>
                <small style="font-weight: 900;">Signature</small>
            </v-flex>
            <v-flex xs12 text-xs-center>
                <v-checkbox  class="ma-1" v-model="esignAgree"
                             hide-details label= 'I understand & agree that my electronic signature is legally binding.'></v-checkbox>
                <v-btn class="mx-2" :disabled="working" @click="signDocument" v-show="esignAgree"  dark small color="primary"><v-icon style="margin-right: 10px" dark>fingerprint</v-icon> Sign Document</v-btn>
            </v-flex>
        </v-layout>
        <v-layout row wrap v-if="document != undefined"  v-show="documentReady && allChecked == false">


            <v-flex xs12>
                <hr/>
                <br/>
                <p><b>Please check all the boxes in the terms above.</b></p>
                <small style="border-top:1px solid black; padding: 5px"><b> {{this.inputCount - this.signedCount}} remaining</b></small>
                 <br/>
            </v-flex>
        </v-layout>
    </v-container>

</template>

<script lang="js">
  export default  {
    name: 'sign-document',
    props: ["formdocument", "preview","formid","redirect"],
    mounted() {

        console.log('form is is', this.formid)
        if (this.formid != undefined) {
            this.$services.forms.get(this.formid).then((result) => {
                console.log('got the result of the get document', result)
                this.document = result
                this.getDocumentReady()
            })
        } else if (this.formdocument != undefined) {
            this.document = this.formdocument
        }
    },
    data() {
      return {
          working: false,
          allChecked: null,
          signedCount: 0,
          inputCount: 0,
          documentReady: false,
          esignAgree: false,
          document: {}
      }
    },
    methods: {
        areAllBoxesChecked() {
            this.signedCount = document.querySelectorAll(".fr-view input:checked").length
            this.inputCount = document.querySelectorAll(".fr-view input").length
            this.allChecked =  this.inputCount==this.signedCount
        },
        getDocumentReady() {
            console.log('in get document ready')
            if (this.document._id != 'SIlociNJovwKUyxR') {
                this.documentReady = true;
                return
            }
            var checkBoxes = document.querySelectorAll(".fr-view input")

            if(checkBoxes.length == 0) {
                setTimeout(()=> {
                    this.getDocumentReady()
                }, 100)
            } else {
                checkBoxes.forEach((checkbox)=>{
                    checkbox.checked = false;
                })
                this.documentReady = true
                this.interval = setInterval(() => this.areAllBoxesChecked(), 500);

            }
        },
        signDocument() {
          this.working = true;
            var vueThis = this
            if(this.preview != true) {
                var dataToPatch = this.$userData.signedDocs

                if(dataToPatch == undefined) {
                    dataToPatch = []
                }

                dataToPatch.push({
                    'form' : this.document._id
                })

                this.$services.users.patch(this.$feathers.get('user')._id,
                    {
                        'signedDocs' : dataToPatch
                    }).then((test) => {
                    console.log('test update', test)

                    this.$userData.signedDocs = test.signedDocs

                    if(vueThis.redirect != "false") {
                        console.log('redirecting to documents')
                        vueThis.$router.push('/Documents')
                    } else {
                        vueThis.$emit("signresult", true)
                    }


                })

            }
        }

    },
    computed: {
        sigTest() {
            return this.$userData.firstName + ' ' + this.$userData.lastName
        }
    }
}
</script>

<style lang="scss">
    .fr-view input {
        cursor:pointer !important;
        vertical-align: middle !important;
    }
</style>
